import { FC } from 'react';
import { Stack, Typography } from '@mui/material';

export const LoginCardFooter: FC = () => {
    const year = new Date().getFullYear();
    return (
        <Stack spacing={0} sx={{ mt: 2, pt: 2, alignItems: 'center' }}>
            <Typography component="p" variant="body2" color="text.secondary" align="center">
                &copy; 2006-{year} Transcepta, LLC.
            </Typography>
        </Stack>
    );
};
